export default function CsharpWhileLoop() {
  return (
    <h2>Csharp While Loop</h2>
  );
}
